import { select, put } from 'redux-saga/effects';
import SubscriptionActions from './SubscriptionRedux';
import { AuthSelectors } from './AuthRedux';

import { transformSubscription } from '@services/transform';
import API from '@utils/api';
import logger from '@utils/logger';
import { trackRecurringStatus } from '@services/analytics';

export function* loadSubscriptions() {
  const state = yield select();
  const properties = yield select(AuthSelectors.selectUserProperties);

  try {
    yield put(SubscriptionActions.setSubscriptionLoading(true));
    let { result } = yield API.getSubscriptions();
    // if (result && Array.isArray(result)) {
    //   result = result.filter(item => item.status === 'active');
    //   if (result.length > 0) {
    //     result = result[0];
    //   } else {
    //     result = null;
    //   }
    // } else if (result && result.status !== 'active') {
    //   result = null;
    // }

    if (!result) {
      throw new Error('No active subscription');
    }

    const serviceTypeData = state.app.data.serviceTypes;
    const addonsData = state.app.data.addons;
    yield put(
      SubscriptionActions.setSubscriptionList(
        transformSubscription(result, serviceTypeData, addonsData, properties)
      )
    );
  } catch (err) {
    yield put(SubscriptionActions.setSubscriptionList(null));
    //TODO: notify error
    logger.error(err);
  }
  yield put(SubscriptionActions.setSubscriptionLoading(false));
  const updatedState = yield select();
  trackRecurringStatus(updatedState);
}
